const siteTitle = 'Dokończ zamówienie';

export default {
  mainTexts: {
    siteTitle: `${siteTitle}`,
    formTitle1: 'Wypełnij swoje dane',
    formTitle2: 'Płacisz tutaj',
    btnForm: 'Kontynuuj',
    btnForm2: 'Zapłać',
    priceText1: 'Płatność',
    priceText2: 'Razem',
    footerTitle: 'Płatność online',
    footerText: 'Potwierdź swoją kartą kredytową',
  },
  home: {
    placeholder: {
      firstName: 'Imie',
      lastName: 'Nazwisko',
      email: 'E-mail',
      phone: 'Telefon',
      city: 'Miasto',
      address: ' Adres',
      zip: 'ZIP',
      continue: 'Kontynuuj',
      name: 'nazwa',
      ConfirmPayment: 'Potwierdź płatność',
    },
    cardNumber: 'Numer karty',
    expirationDate: 'Data ważności',
    name: 'nazwa',
    month: 'miesiąc',
    year: 'rok',
    cvv: 'CVV',
    confirmPayment: 'Potwierdź płatność',
    timer: 'Pozostały czas do opłacenia zamówienia',
  },
  validation: {
    requireEmail: 'Twój e-mail jest pusty.',
    validEmail: 'E-mail jest nieprawidłowy.',
    requirePhone: 'Twój telefon jest pusty.',
    minPhone: 'Pole telefonu musi mieć co najmniej 10 znaków.',
    requireFirstName: 'Imię jest wymagane.',
    validFirstName: 'Imię jest nieprawidłowe',
    requireLastName: 'Pole nazwiska jest wymagane.',
    validLastName: 'Pole nazwiska jest nieprawidłowe',
    requireCity: 'Pole miasta jest wymagane.',
    validCity: 'Pole miasta jest nieprawidłowe',
    requiredAddress: 'Pole adresu jest wymagane.',
    validAddress: 'Pole adresu jest nieprawidłowe',
    requireZip: 'Pole zip jest wymagane.',
    validZip: 'Pole zip jest nieprawidłowe.',
    requireCard: 'Pole numeru karty jest wymagane.',
    minCard: 'Za mało symboli.',
    validCard: 'Pole numeru karty jest nieprawidłowe.',
    requireMonth: 'Wymagane jest pole miesiąca wygaśnięcia.',
    requireYear: 'Wymagane jest pole roku wygaśnięcia.',
    requireName: 'Pole nazwy jest wymagane.',
    validName: 'Pole nazwy jest nieprawidłowe.',
    requireCvv: 'Pole cvv jest wymagane.',
    validCvv: 'Pole cvv jest nieprawidłowe.',
    minFirstName: 'Pole na imię musi mieć co najmniej 3 znaki.',
    minLastName: 'Pole na nazwisko musi mieć co najmniej 3 znaki.',
    minCity: 'Pole miasta musi mieć co najmniej 3 znaki.',
    minAddress: 'Pole adresu musi mieć co najmniej 3 znaki.',
    minZip: 'Pole kodu pocztowego musi mieć co najmniej 3 znaki.',
    minName: 'Pole nazwy musi mieć co najmniej 3 znaki.',
    minCvv: 'Pole cvv musi mieć co najmniej 3 znaki.',
    specialFirstName: 'Imię w polu nie może zawierać znaków specjalnych',
    specialLastName: 'Nazwisko w polu nie może zawierać znaków specjalnych',
    specialName: 'Nazwa pola nie może zawierać znaków specjalnych',
    specialCity: 'W polu miasto nie może zawierać znaków specjalnych',
  },
  mask: {
    phone: '+48 9999 99999',
    zip: 'XXXXXX XX9',
    creditCard: '9999 9999 9999 9999',
    cvv: '9999',
  },
  getInTouch: {
    title: 'GET IN TOUCH',
    firstName: 'Vornamee',
    lastName: 'Nachname',
    email: 'E-mail',
    msg: 'Nachricht',
    send: 'Senden',
    alreadyRegistered: 'Sie haben sich bereits registriert',
    unsubscribeLink: 'Link abbestellen',
    worktime: 'Callcenter Arbeitet von 10 bis 17 Uhr',
    phone: 'Telefon: Sofia +359 2 437 4207',
  },
};
